import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Collapse, Tree } from "antd";
/**
 * 折疊樹狀
 */

const {
  Panel
} = Collapse;

const CollapseTree = ({
  dataFetching = false,
  accordion = true,
  treeData = [],
  panelData = [],
  checkedList = [],
  activeKey = [],
  onChange = () => {},
  onPanelChange = () => {}
}) => {
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const onExpand = expandedKeysValue => {
    setAutoExpandParent(false);
  };

  const onCheck = checkedKeysValue => {
    onChange && onChange(checkedKeysValue);
  };

  function callback(key) {
    onPanelChange && onPanelChange(key);
  }

  const collapsible = useMemo(() => {
    return dataFetching ? "disabled" : "";
  }, [dataFetching]);
  return /*#__PURE__*/React.createElement(Collapse, {
    activeKey: activeKey,
    collapsible: collapsible,
    accordion: accordion,
    onChange: callback
  }, panelData && panelData.map((item, index) => /*#__PURE__*/React.createElement(Panel, {
    header: item.name,
    key: index
  }, dataFetching ? "loading..." : /*#__PURE__*/React.createElement(Tree, {
    checkable: true,
    onExpand: onExpand,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck,
    checkedKeys: checkedList,
    treeData: treeData,
    selectable: false
  }))));
};

export default CollapseTree;
CollapseTree.propTypes = {
  activeKey: PropTypes.any,
  dataFetching: PropTypes.bool,
  accordion: PropTypes.bool,
  treeData: PropTypes.array,
  panelData: PropTypes.array,
  checkedList: PropTypes.array,
  onChange: PropTypes.func,
  onPanelChange: PropTypes.func
};